<template lang="pug">
.unread-notifications-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc)
    div(slot="modal-title")
      span.title 未読のお知らせがありますので、ご確認ください

    UnReadNotificationTable(v-model="notifications" @onNotification="onNotification")

    div(slot="modal-footer" slot-scope="{ cancel }")
      button.btn.modal-cancel-btn(type="button" @click="cancel()") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { notificationStore } from "@/store/store";
import { PcUrl } from "@/commons/constants/PcUrl";
import UnReadNotificationTable, { UnReadNotificationTableItem } from "@/pc/containers/notifications/UnReadNotificationTable.vue";

/**
 * ### 未読お知らせモーダル
 */
@Component({
  components: {
    UnReadNotificationTable
  }
})
export default class UnReadNotificationsModal extends Vue {
  /** 表示可否 */
  @Prop({
    required: true
  })
  value!: boolean;
  /** 未読お知らせ */
  @Prop({ required: true })
  notifications!: Array<UnReadNotificationTableItem>;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public onNotification(notification: UnReadNotificationTableItem): void {
    // 個別にお知らせを取得するAPIは無いので、本画面表示の際に取得した情報をstoreに格納して受け渡す
    notificationStore.setNotification({ notification });
    this.$emit("input", false);
    this.$router.push(PcUrl.NotificationDetail);

    return;
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
}
</style>
